module.exports = __webpack_public_path__ + "img/activityscoreimportoutput.2f8fcb2e.png";